import React from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

const AddPackages = () => {
  const packages = [
    // Student Plans - Breakfast
    {
      name: "Student Breakfast",
      description: "Affordable and nutritious breakfast options perfect for students. Includes variety rice, poriyal, and simple curries.",
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      price: 600,
      mealsPerDay: 1,
      cuisineType: "Mixed",
      mealType: "breakfast",
      isPureVeg: true,
      isAvailable: true,
      category: "Student Plans"
    },
    // Student Plans - Lunch
    {
      name: "Student Lunch",
      description: "Delicious and budget-friendly lunch options featuring variety rice, poriyal, and simple curries.",
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      price: 800,
      mealsPerDay: 1,
      cuisineType: "Mixed",
      mealType: "lunch",
      isPureVeg: true,
      isAvailable: true,
      category: "Student Plans"
    },
    // Student Plans - Dinner
    {
      name: "Student Dinner",
      description: "Comforting dinner options with variety rice, poriyal, and simple curries for students.",
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      price: 800,
      mealsPerDay: 1,
      cuisineType: "Mixed",
      mealType: "dinner",
      isPureVeg: true,
      isAvailable: true,
      category: "Student Plans"
    },

    // South Indian - Breakfast
    {
      name: "South Indian Breakfast",
      description: "Authentic South Indian breakfast featuring dosas, idlis, vadas, and traditional accompaniments.",
      imageUrl: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400&h=400&fit=crop",
      price: 800,
      mealsPerDay: 1,
      cuisineType: "South Indian",
      mealType: "breakfast",
      isPureVeg: true,
      isAvailable: true,
      category: "South Indian"
    },
    // South Indian - Lunch
    {
      name: "South Indian Lunch",
      description: "Traditional South Indian lunch with rice, sambar, rasam, and vegetable curries.",
      imageUrl: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400&h=400&fit=crop",
      price: 1000,
      mealsPerDay: 1,
      cuisineType: "South Indian",
      mealType: "lunch",
      isPureVeg: true,
      isAvailable: true,
      category: "South Indian"
    },
    // South Indian - Dinner
    {
      name: "South Indian Dinner",
      description: "Evening South Indian meal with dosas, idlis, and light accompaniments.",
      imageUrl: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400&h=400&fit=crop",
      price: 1000,
      mealsPerDay: 1,
      cuisineType: "South Indian",
      mealType: "dinner",
      isPureVeg: true,
      isAvailable: true,
      category: "South Indian"
    },

    // North Indian - Breakfast
    {
      name: "North Indian Breakfast",
      description: "Hearty North Indian breakfast with parathas, aloo sabzi, and traditional accompaniments.",
      imageUrl: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=400&h=400&fit=crop",
      price: 900,
      mealsPerDay: 1,
      cuisineType: "North Indian",
      mealType: "breakfast",
      isPureVeg: true,
      isAvailable: true,
      category: "North Indian"
    },
    // North Indian - Lunch
    {
      name: "North Indian Lunch",
      description: "Rich North Indian lunch with rotis, curries, dal, and vegetable dishes.",
      imageUrl: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=400&h=400&fit=crop",
      price: 1200,
      mealsPerDay: 1,
      cuisineType: "North Indian",
      mealType: "lunch",
      isPureVeg: true,
      isAvailable: true,
      category: "North Indian"
    },
    // North Indian - Dinner
    {
      name: "North Indian Dinner",
      description: "Comforting North Indian dinner with rotis, curries, and traditional accompaniments.",
      imageUrl: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=400&h=400&fit=crop",
      price: 1200,
      mealsPerDay: 1,
      cuisineType: "North Indian",
      mealType: "dinner",
      isPureVeg: true,
      isAvailable: true,
      category: "North Indian"
    },

    // Diet Plans - Breakfast
    {
      name: "Diet Breakfast",
      description: "Healthy breakfast designed for weight management with oats, fruits, and protein-rich options.",
      imageUrl: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=400&fit=crop",
      price: 1000,
      mealsPerDay: 1,
      cuisineType: "Diet",
      mealType: "breakfast",
      isPureVeg: true,
      isAvailable: true,
      category: "Diet Plans"
    },
    // Diet Plans - Lunch
    {
      name: "Diet Lunch",
      description: "Balanced lunch for fitness goals with quinoa, vegetables, and lean protein options.",
      imageUrl: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=400&fit=crop",
      price: 1200,
      mealsPerDay: 1,
      cuisineType: "Diet",
      mealType: "lunch",
      isPureVeg: true,
      isAvailable: true,
      category: "Diet Plans"
    },
    // Diet Plans - Dinner
    {
      name: "Diet Dinner",
      description: "Light and nutritious dinner for weight management with healthy grains and vegetables.",
      imageUrl: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=400&fit=crop",
      price: 1200,
      mealsPerDay: 1,
      cuisineType: "Diet",
      mealType: "dinner",
      isPureVeg: true,
      isAvailable: true,
      category: "Diet Plans"
    },

    // Premium Plans - Breakfast
    {
      name: "Premium Breakfast",
      description: "Gourmet breakfast with premium ingredients, diverse cuisines, and restaurant-quality presentation.",
      imageUrl: "https://images.unsplash.com/photo-1504674900240-9a9049b7d8ce?w=400&h=400&fit=crop",
      price: 1500,
      mealsPerDay: 1,
      cuisineType: "Premium",
      mealType: "breakfast",
      isPureVeg: true,
      isAvailable: true,
      category: "Premium Plans"
    },
    // Premium Plans - Lunch
    {
      name: "Premium Lunch",
      description: "Exquisite lunch with premium ingredients, diverse cuisines, and fine dining experience.",
      imageUrl: "https://images.unsplash.com/photo-1504674900240-9a9049b7d8ce?w=400&h=400&fit=crop",
      price: 1800,
      mealsPerDay: 1,
      cuisineType: "Premium",
      mealType: "lunch",
      isPureVeg: true,
      isAvailable: true,
      category: "Premium Plans"
    },
    // Premium Plans - Dinner
    {
      name: "Premium Dinner",
      description: "Sophisticated dinner with premium ingredients, diverse cuisines, and elegant presentation.",
      imageUrl: "https://images.unsplash.com/photo-1504674900240-9a9049b7d8ce?w=400&h=400&fit=crop",
      price: 1800,
      mealsPerDay: 1,
      cuisineType: "Premium",
      mealType: "dinner",
      isPureVeg: true,
      isAvailable: true,
      category: "Premium Plans"
    }
  ];

  const addPackages = async () => {
    try {
      for (const pkg of packages) {
        await addDoc(collection(db, 'packages'), pkg);
        console.log(`Added package: ${pkg.name}`);
      }
      alert('All breakfast, lunch, and dinner packages added successfully!');
    } catch (error) {
      console.error('Error adding packages:', error);
      alert('Error adding packages. Please check console.');
    }
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Add Breakfast, Lunch & Dinner Packages</h2>
      <p>This will add breakfast, lunch, and dinner packages for all categories to the packages collection.</p>
      <button 
        onClick={addPackages}
        style={{
          padding: '12px 24px',
          backgroundColor: '#10b981',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        Add Packages
      </button>
    </div>
  );
};

export default AddPackages;
